import { render, staticRenderFns } from "./_bulk_tag_items_modal.vue?vue&type=template&id=33e2628c&scoped=true&"
import script from "./_bulk_tag_items_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_tag_items_modal.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_tag_items_modal.vue?vue&type=style&index=0&id=33e2628c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2628c",
  null
  
)

export default component.exports